///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, itemCatalogActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getItemCatalog = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const bodyMsg = payload.filters

	const apiCall = R.GET_ITEM_CATALOG(payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(itemCatalogActionCreators.getItemCatalogSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(itemCatalogActionCreators.getItemCatalogFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getSaleOrderByCode = function* ({ payload }) {
	const user = yield select(selectIdsUser)

	const apiCall = R.GET_SALE_ORDER_BY_CODE(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(itemCatalogActionCreators.getSaleOrderByCodeSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(itemCatalogActionCreators.getSaleOrderByCodeFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postCreateCode = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_CREATE_CODE()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.bodyData)

		yield put(itemCatalogActionCreators.postCreateCodeSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(itemCatalogActionCreators.postCreateCodeFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postSendCode = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_SEND_CODE(payload.id, payload.slug, payload.urlParam, payload.email)

	const toastMsg = payload.bodyData ? 'toast__salesByCode__sentBySMS_success' : 'toast__salesByCode__sentByMail_success'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const method = payload.bodyData ? yield API_TOKEN(user.jwt).post(apiCall, payload.bodyData) : yield API_TOKEN(user.jwt).get(apiCall)
		const data = method

		yield put(itemCatalogActionCreators.postSendCodeSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(toastMsg))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(itemCatalogActionCreators.postSendCodeFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_ITEM_CATALOG, getItemCatalog)
	yield takeLatest(ActionsTypes.GET_SALE_ORDER_BY_CODE, getSaleOrderByCode)
	yield takeLatest(ActionsTypes.POST_CREATE_CODE, postCreateCode)
	yield takeLatest(ActionsTypes.POST_SEND_CODE, postSendCode)
}

export default sagas
